import { CalendarIcon, RepeatIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertIcon,
  Badge,
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { FaUniversity } from "react-icons/fa";
import { useSelector } from "react-redux";
import { ExportButton } from "../components/ui/exportButton";
import { OverlayLoader } from "../components/ui/overlay-loader";
import { secureFetch } from "../data/secureFetch";
import { useFileExport } from "../hooks/use-file-export";
import { MAX_EXPORT_SIZE } from "../utils/constants";
import { builQueryString, fiterFilters, objectToString } from "../utils/parser";
import UniversalTable from "./UniversalTable";

const defaultWithdrawalPagination = {
  page: 1,
  itemsPerPage: 20,
  totalItems: 0,
  totalPages: 0,
};

const defaultWithdrawalsFilter = {
  status: "",

  start_date: "",
  end_date: "",

  total_amount_min: "",
  total_amount_max: "",
  page: 1,
  itemsPerPage: 20,
  // organization_id: "",
  // type: "",
  // merchant_id: "",
  // net_amount_min: "",
  // net_amount_max: "",
  // total_fees_min: "",
  // total_fees_max: "",

  // window_start_time: "",
  // window_end_time: "",
};

function WithdrawalFilters({
  filters,
  updateFilter,
  handleReset,
  handleExport,
  exportLoading = false,
  onRefresh,
  isLoading,
  organizations = [], // Array of {id, name}
  merchants = [], // Array of {id, name}
}) {
  return (
    <Box mb={6}>
      <Flex align="center" justify="space-between" flexWrap="wrap" gap={4}>
        <Flex
          align="center"
          justify="space-between"
          p={4}
          borderRadius="lg"
          gap={6}
        >
          <InputGroup width={["100%", "260px"]}>
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.400" />
            </InputLeftElement>

            <Input
              variant="filled"
              placeholder="Search withdrawals..."
              value={filters.search}
              onChange={(e) => updateFilter("search", e.target.value)}
            />
          </InputGroup>
          {onRefresh && (
            <Button
              leftIcon={<RepeatIcon />}
              colorScheme="blue"
              variant="solid"
              onClick={onRefresh}
              px={4}
              _hover={{ transform: "scale(1.05)" }}
              transition="all 0.2s"
              isLoading={isLoading}
              loadingText="Refreshing"
            >
              Refresh
            </Button>
          )}
        </Flex>
        {/* RIGHT SECTION */}
        <Flex align="center" gap={3}>
          {/* FILTER POPUP */}
          <Popover placement="bottom-end">
            <PopoverTrigger>
              <Button colorScheme="gray" variant="outline">
                Filters
              </Button>
            </PopoverTrigger>

            <PopoverContent
              p={4}
              borderRadius="lg"
              shadow="xl"
              width="300px"
              maxHeight="70vh"
              overflowY="auto"
            >
              <PopoverArrow />
              <PopoverCloseButton />

              <PopoverBody pt={4}>
                {/* STATUS */}
                <Select
                  placeholder="Status"
                  value={filters.status}
                  onChange={(e) => updateFilter("status", e.target.value)}
                  mb={4}
                >
                  <option value="pending">Pending</option>
                  <option value="awaiting_approval">Awaiting Approval</option>
                  <option value="approved">Approved</option>
                  <option value="paid">Paid</option>
                  <option value="failed">Failed</option>
                  <option value="canceled">Canceled</option>
                  <option value="processing">Processing</option>
                  <option value="completed">Completed</option>
                </Select>

                {/* ORGANIZATION */}
                {/* {organizations.length > 0 && (
                  <Select
                    placeholder="Organization"
                    value={filters.organization_id}
                    onChange={(e) =>
                      updateFilter("organization_id", e.target.value)
                    }
                    mb={4}
                  >
                    {organizations.map((org) => (
                      <option key={org.id} value={org.id}>
                        {org.name}
                      </option>
                    ))}
                  </Select>
                )} */}

                {/* TYPE */}
                {/* <Select
                  placeholder="Type"
                  value={filters.type}
                  onChange={(e) => updateFilter("type", e.target.value)}
                  mb={4}
                >
                  <option value="manual">Manual</option>
                  <option value="automatic">Automatic</option>
                  <option value="scheduled">Scheduled</option>
                  <option value="instant">Instant</option>
                </Select> */}

                {/* MERCHANT */}
                {/* {merchants.length > 0 && (
                  <Select
                    placeholder="Merchant"
                    value={filters.merchant_id}
                    onChange={(e) =>
                      updateFilter("merchant_id", e.target.value)
                    }
                    mb={4}
                  >
                    {merchants.map((merchant) => (
                      <option key={merchant.id} value={merchant.id}>
                        {merchant.name}
                      </option>
                    ))}
                  </Select>
                )} */}

                {/* NET AMOUNT RANGE */}
                {/* <FormLabel fontSize="sm" mb={2} fontWeight="medium">
                  Net Amount Range ($)
                </FormLabel>
                <Flex gap={3} mb={4}>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">$</InputLeftElement>
                    <Input
                      variant="filled"
                      type="number"
                      placeholder="Min"
                      value={filters.net_amount_min}
                      onChange={(e) =>
                        updateFilter("net_amount_min", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputLeftElement pointerEvents="none">$</InputLeftElement>
                    <Input
                      variant="filled"
                      type="number"
                      placeholder="Max"
                      value={filters.net_amount_max}
                      onChange={(e) =>
                        updateFilter("net_amount_max", e.target.value)
                      }
                    />
                  </InputGroup>
                </Flex> */}

                {/* TOTAL AMOUNT RANGE */}
                <FormLabel fontSize="sm" mb={2} fontWeight="medium">
                  Amount Range ($)
                </FormLabel>
                <Flex gap={3} mb={4}>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">$</InputLeftElement>
                    <Input
                      variant="filled"
                      type="number"
                      placeholder="Min"
                      value={filters.total_amount_min}
                      onChange={(e) =>
                        updateFilter("total_amount_min", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputLeftElement pointerEvents="none">$</InputLeftElement>
                    <Input
                      variant="filled"
                      type="number"
                      placeholder="Max"
                      value={filters.total_amount_max}
                      onChange={(e) =>
                        updateFilter("total_amount_max", e.target.value)
                      }
                    />
                  </InputGroup>
                </Flex>

                {/* TOTAL FEES RANGE */}
                {/* <FormLabel fontSize="sm" mb={2} fontWeight="medium">
                  Total Fees Range ($)
                </FormLabel>
                <Flex gap={3} mb={4}>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">$</InputLeftElement>
                    <Input
                      variant="filled"
                      type="number"
                      placeholder="Min"
                      value={filters.total_fees_min}
                      onChange={(e) =>
                        updateFilter("total_fees_min", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputLeftElement pointerEvents="none">$</InputLeftElement>
                    <Input
                      variant="filled"
                      type="number"
                      placeholder="Max"
                      value={filters.total_fees_max}
                      onChange={(e) =>
                        updateFilter("total_fees_max", e.target.value)
                      }
                    />
                  </InputGroup>
                </Flex> */}

                {/* CREATED DATE RANGE */}
                <FormLabel fontSize="sm" mb={2} fontWeight="medium">
                  Created Date Range
                </FormLabel>
                <Flex direction="column" gap={3} mb={4}>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <CalendarIcon color="gray.400" fontSize="sm" />
                    </InputLeftElement>
                    <Input
                      variant="filled"
                      type="date"
                      placeholder="From"
                      value={filters.start_date}
                      onChange={(e) =>
                        updateFilter("start_date", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <CalendarIcon color="gray.400" fontSize="sm" />
                    </InputLeftElement>
                    <Input
                      variant="filled"
                      type="date"
                      placeholder="To"
                      value={filters.end_date}
                      onChange={(e) => updateFilter("end_date", e.target.value)}
                    />
                  </InputGroup>
                </Flex>

                {/* SETTLEMENT WINDOW DATE RANGE (OPTIONAL) */}
                {/* <FormLabel fontSize="sm" mb={2} fontWeight="medium">
                  Settlement Window Range
                </FormLabel>
                <Flex direction="column" gap={3} mb={4}>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <CalendarIcon color="gray.400" fontSize="sm" />
                    </InputLeftElement>
                    <Input
                      variant="filled"
                      type="date"
                      placeholder="Window Start"
                      value={filters.window_start_time}
                      onChange={(e) =>
                        updateFilter("window_start_time", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <CalendarIcon color="gray.400" fontSize="sm" />
                    </InputLeftElement>
                    <Input
                      variant="filled"
                      type="date"
                      placeholder="Window End"
                      value={filters.window_end_time}
                      onChange={(e) =>
                        updateFilter("window_end_time", e.target.value)
                      }
                    />
                  </InputGroup>
                </Flex> */}

                {/* RESET */}
                <Button
                  width="100%"
                  mt={2}
                  colorScheme="red"
                  variant="outline"
                  onClick={handleReset}
                >
                  Reset Filters
                </Button>
              </PopoverBody>
            </PopoverContent>
          </Popover>

          {/* EXPORT DROPDOWN */}
          <ExportButton
            exportLoading={exportLoading}
            handleExport={handleExport}
          />
        </Flex>
      </Flex>
    </Box>
  );
}
const Banking = () => {
  const { exportFile } = useFileExport();
  const { stripe_connected_account_id, uid, organizationId } = useSelector(
    (state) => state.user,
  );

  // SEPARATE LOADING STATES
  const [withdrawalsLoading, setWithdrawalsLoading] = useState(false); // For table data fetching
  const [overlayLoading, setOverlayLoading] = useState(null); // "setup" | "continue" | null
  const [actionLoading, setActionLoading] = useState(false); // For button actions

  const [withdrawals, setWithdrawals] = useState([]);
  const [pagination, setPagination] = useState(defaultWithdrawalPagination);
  const [error, setError] = useState(null);

  const [organizationInfo, setOrganizationInfo] = useState(null);
  const [organizationInfoLoading, setOrganizationInfoLoading] = useState(true);
  const toast = useToast();

  const [filters, setFilters] = useState(defaultWithdrawalsFilter);
  const [exportLoading, setExportLoading] = useState(false);
  const [sortRules, setSortRules] = useState([]);

  const updateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const fetchOrganizationInfo = async () => {
      if (!organizationId) {
        setOrganizationInfoLoading(false);
        return;
      }

      setOrganizationInfoLoading(true);
      try {
        const response = await secureFetch(
          `/api/organizations/${organizationId}`,
        );
        if (response.ok) {
          const data = response;
          setOrganizationInfo(data);
        } else {
          throw new Error("Failed to fetch organization details.");
        }
      } catch (error) {
        toast({
          title: "Error",
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setOrganizationInfoLoading(false);
      }
    };

    fetchOrganizationInfo();
  }, [organizationId, toast]);

  const fetchWithdrawals = useCallback(async () => {
    if (!stripe_connected_account_id) return;
    setWithdrawalsLoading(true); // Use withdrawals loading
    try {
      const queryString = builQueryString(filters);

      const response = await secureFetch(
        `/api/withdrawals/list/${queryString}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {},
        },
      );
      if (response.ok) {
        // Response structure: { data: [...], pagination: {...} }
        // Support both new format (data) and old format (array) for backward compatibility
        let withdrawalsData = [];
        let paginationData = defaultWithdrawalPagination;

        if (response.data) {
          // New format: { data: [...], pagination: {...} }
          withdrawalsData = response.data;
          paginationData = response.pagination || defaultWithdrawalPagination;
        } else if (Array.isArray(response)) {
          // Old format: array directly
          withdrawalsData = response;
          paginationData = {
            page: filters.page || 1,
            itemsPerPage: filters.itemsPerPage || 20,
            totalItems: response.length,
            totalPages: Math.ceil(
              response.length / (filters.itemsPerPage || 20),
            ),
          };
        }

        setWithdrawals(withdrawalsData);
        setPagination(paginationData);
      } else {
        throw new Error("Failed to fetch withdrawals.");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setWithdrawalsLoading(false);
    }
  }, [stripe_connected_account_id, filters, toast]);

  const handleExport = async (format = "csv") => {
    try {
      setExportLoading(true);

      // Build export filters without pagination limits
      const exportFilters = {
        ...filters,
        page: 1,
        itemsPerPage: MAX_EXPORT_SIZE, // Maximum for export
      };

      // Remove pagination params if not needed in query

      const queryString = builQueryString(exportFilters);

      const response = await secureFetch(
        `/api/withdrawals/list/${queryString}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {},
        },
      );
      if (response.ok) {
        // Response structure: { data: [...], pagination: {...} }
        // Support both new format (data) and old format (array) for backward compatibility
        const withdrawalsData =
          response.data || (Array.isArray(response) ? response : []);
        const withdrawals = withdrawalsData.map((withdrawal) => {
          const organization = withdrawal.organization_name;
          return {
            ...withdrawal,
            organization,
          };
        });

        exportFile({
          format,
          data: withdrawals,
          columns,
          exportFileName: "Withdrawals Records",
          tableName: "Withdrawals Records",
          filtersValues: filters,
          sortRules,
        });
      } else {
        throw new Error("Failed to fetch Withdrawals.");
      }
    } catch (err) {
      setError();
      toast({
        position: "top-right",
        title: `Export failed: ${err.message}`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setExportLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals();
  }, [fetchWithdrawals]);

  // Define columns for the UniversalTable
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ row }) => (
          <Link to={`/withdrawals/${row.original.id}`}>{row.original.id}</Link>
        ),
      },

      {
        Header: "Amount",
        accessor: "total_amount",
        Cell: ({ value }) => {
          const amount = value ? (value / 100).toFixed(2) : "0.00";
          return `$${amount}`;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
          let colorScheme;
          let text;

          switch (value?.toLowerCase()) {
            case "pending":
            case "awaiting_approval":
              colorScheme = "yellow";
              text = value
                .replace("_", " ")
                .replace(/\b\w/g, (l) => l.toUpperCase());
              break;
            case "approved":
            case "completed":
            case "paid":
              colorScheme = "green";
              text = value.charAt(0).toUpperCase() + value.slice(1);
              break;
            case "failed":
            case "canceled":
            case "reversed":
              colorScheme = "red";
              text = value.charAt(0).toUpperCase() + value.slice(1);
              break;
            case "processing":
              colorScheme = "blue";
              text = "Processing";
              break;
            default:
              colorScheme = "gray";
              text = value || "Unknown";
          }

          return <Badge colorScheme={colorScheme}>{text}</Badge>;
        },
      },

      {
        Header: "Created",
        accessor: "created_at",
        Cell: ({ value }) => {
          if (!value) return "N/A";
          const date = new Date(value);
          return (
            <Box>
              <Text fontSize="sm">{date.toLocaleDateString()}</Text>
              <Text fontSize="xs" color="gray.500">
                {date.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </Text>
            </Box>
          );
        },
      },

      // {
      //   Header: "Legacy settlement ID",
      //   accessor: "finix_settlement_id",
      //   Cell: ({ value }) => value || "N/A",
      // },
      // {
      //   Header: "Organization",
      //   id: "organization",
      //   Cell: ({ row }) => (
      //     <>
      //       <Text fontSize="sm" fontWeight="medium">
      //         {row.original.organization_name || "N/A"}
      //       </Text>
      //       {row.original.organization_id && (
      //         <Text fontSize="xs" color="gray.500">
      //           ID: {row.original.organization_id}
      //         </Text>
      //       )}
      //     </>
      //   ),
      // },
      // {
      //   Header: "Net Amount",
      //   accessor: "net_amount",
      //   Cell: ({ value }) => {
      //     const amount = value ? (value / 100).toFixed(2) : "0.00";
      //     return <Text fontWeight="medium">${amount}</Text>;
      //   },
      // },

      // {
      //   Header: "Total Fees",
      //   accessor: "total_fees",
      //   Cell: ({ value }) => {
      //     const amount = value ? (value / 100).toFixed(2) : "0.00";
      //     return <Text color="red.600">${amount}</Text>;
      //   },
      // },
      // {
      //   Header: "Currency",
      //   accessor: "currency",
      //   Cell: ({ value }) => <Badge colorScheme="blue">{value || "USD"}</Badge>,
      // },
      //
      // {
      //   Header: "Type",
      //   accessor: "type",
      //   Cell: ({ value }) => {
      //     let colorScheme;
      //     let text;

      //     switch (value?.toLowerCase()) {
      //       case "manual":
      //         colorScheme = "orange";
      //         text = "Manual";
      //         break;
      //       case "automatic":
      //         colorScheme = "green";
      //         text = "Automatic";
      //         break;
      //       case "scheduled":
      //         colorScheme = "blue";
      //         text = "Scheduled";
      //         break;
      //       case "instant":
      //         colorScheme = "purple";
      //         text = "Instant";
      //         break;
      //       default:
      //         colorScheme = "gray";
      //         text = value || "Unknown";
      //     }

      //     return <Badge colorScheme={colorScheme}>{text}</Badge>;
      //   },
      // },
      // {
      //   Header: "Merchant ID",
      //   accessor: "merchant_id",
      //   Cell: ({ value }) => value || "N/A",
      // },

      // {
      //   Header: "Updated",
      //   accessor: "updated_at",
      //   Cell: ({ value }) => {
      //     if (!value) return "N/A";
      //     const date = new Date(value);
      //     return (
      //       <Box>
      //         <Text fontSize="sm">{date.toLocaleDateString()}</Text>
      //         <Text fontSize="xs" color="gray.500">
      //           {date.toLocaleTimeString([], {
      //             hour: "2-digit",
      //             minute: "2-digit",
      //           })}
      //         </Text>
      //       </Box>
      //     );
      //   },
      // },
      // {
      //   Header: "Window Start",
      //   accessor: "window_start_time",
      //   Cell: ({ value }) => {
      //     if (!value) return "N/A";
      //     const date = new Date(value);
      //     return (
      //       <Box>
      //         <Text fontSize="sm">{date.toLocaleDateString()}</Text>
      //         <Text fontSize="xs" color="gray.500">
      //           {date.toLocaleTimeString([], {
      //             hour: "2-digit",
      //             minute: "2-digit",
      //           })}
      //         </Text>
      //       </Box>
      //     );
      //   },
      // },
      // {
      //   Header: "Window End",
      //   accessor: "window_end_time",
      //   Cell: ({ value }) => {
      //     if (!value) return "N/A";
      //     const date = new Date(value);
      //     return (
      //       <Box>
      //         <Text fontSize="sm">{date.toLocaleDateString()}</Text>
      //         <Text fontSize="xs" color="gray.500">
      //           {date.toLocaleTimeString([], {
      //             hour: "2-digit",
      //             minute: "2-digit",
      //           })}
      //         </Text>
      //       </Box>
      //     );
      //   },
      // },
      // {
      //   Header: "Actions",
      //   id: "actions",
      //   Cell: ({ row }) => (
      //     <IconButton
      //       as={Link}
      //       to={`/withdrawals/${row.original.id}`}
      //       icon={<ExternalLinkIcon />}
      //       size="xs"
      //       variant="outline"
      //       aria-label="View Details"
      //     />
      //   ),
      // },
    ],
    [],
  );
  const handleSetupAccount = async () => {
    setActionLoading(true);
    setOverlayLoading("setup"); // Use overlay loading for setup account
    try {
      const response = await secureFetch(`/api/onboarding`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: { uid },
      });

      if (!response.ok) throw new Error("Failed to fetch onboarding link");
      const jsonResponse = response;
      const newOnboardingFormId = jsonResponse?.account_id;
      const newApplicationId = jsonResponse?.account_id;

      if (!newApplicationId)
        throw new Error("Application ID not found in the response");

      const updateResponse = await secureFetch(
        `/api/organizations/onboarding-ids`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            applicationId: newApplicationId,
            onboardingFormId: newOnboardingFormId,
          },
        },
      );

      if (!updateResponse.ok)
        throw new Error("Failed to update organization with application ID");

      window.location.href = jsonResponse?.onboarding_link?.link_url;
    } catch (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setOverlayLoading(null);
    } finally {
      setActionLoading(false);
    }
    // Note: We don't set overlayLoading false on success because we're redirecting
  };

  const handleContinueApplication = async () => {
    setActionLoading(true);
    setOverlayLoading("continue"); // Use overlay loading for continue application
    try {
      // Always continue against the existing connected account so Stripe returns a
      // fresh, valid onboarding link instead of creating a duplicate account.
      const existingAccountId =
        organizationInfo?.stripe_connected_account_id ||
        organizationInfo?.application_id ||
        organizationInfo?.onboarding_form_id ||
        stripe_connected_account_id ||
        "";

      const response = await secureFetch(
        `/api/onboarding/get-onboarding-form/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: { onboardingFormId: existingAccountId },
        },
      );

      if (!response.ok)
        throw new Error(response.message || "Failed to fetch onboarding form");
      const jsonResponse = response;

      const continueUrl = jsonResponse?.onboarding_link?.link_url;
      if (!continueUrl) {
        throw new Error("Stripe did not return a valid onboarding link.");
      }
      window.location.href = continueUrl;
    } catch (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setOverlayLoading(null);
    } finally {
      setActionLoading(false);
    }
    // Note: We don't set overlayLoading false on success because we're redirecting
  };

  const handleRefresh = () => {
    setFilters(defaultWithdrawalsFilter);
    fetchWithdrawals();
  };

  // Loading overlay for setup/continue actions
  const { application_id, onboarding_form_id, application_status } =
    organizationInfo || {};
  // The org already has a Stripe account if any account reference exists. When true we
  // must CONTINUE that application (generate a fresh link) rather than create a new one.
  const hasExistingStripeAccount = Boolean(
    organizationInfo?.stripe_connected_account_id ||
      application_id ||
      onboarding_form_id ||
      stripe_connected_account_id,
  );
  const supportEmail = `support@${window.location.hostname}`;

  if (organizationInfoLoading) {
    return (
      <Box p={5} position="relative" minH="50vh">
        <OverlayLoader isOpen={true} text="Loading banking information..." />
      </Box>
    );
  }

  const pendingStripeRequirements = Number(
    organizationInfo?.stripe_requirements_pending_count || 0,
  );
  const stripeNeedsMoreInformation =
    application_status === "action_required" || pendingStripeRequirements > 0;

  if (stripeNeedsMoreInformation) {
    return (
      <Box p={5} maxW="640px" mx="auto" mt={6}>
        <Helmet>
          <title>Banking - PurelyGive</title>
        </Helmet>
        <OverlayLoader
          isOpen={Boolean(overlayLoading)}
          text={
            overlayLoading === "setup"
              ? "Opening Stripe…"
              : "Continuing in Stripe…"
          }
        />
        <Alert status="warning" borderRadius="md" mb={6}>
          <AlertIcon />
          <Box>
            <Text fontWeight="bold" mb={1}>
              Your Stripe account needs more information
            </Text>
            <Text fontSize="sm">
              {pendingStripeRequirements > 0
                ? `Stripe reports ${pendingStripeRequirements} required item(s) before payouts and compliance are complete. PurelyGive stays in sync with Stripe when you open this page.`
                : "Finish the outstanding items in Stripe to accept donations and withdrawals without interruption."}
            </Text>
          </Box>
        </Alert>
        <Button
          colorScheme="orange"
          size="lg"
          leftIcon={<FaUniversity />}
          onClick={() => {
            if (hasExistingStripeAccount) {
              setOverlayLoading("continue");
              handleContinueApplication();
            } else {
              setOverlayLoading("setup");
              handleSetupAccount();
            }
          }}
          isLoading={actionLoading}
        >
          Continue in Stripe
        </Button>
      </Box>
    );
  }

  // if (true) {
  if (application_status === "active") {
    return (
      <Box p={5} position="relative">
        {/* <Box p={5} position="relative" height={"60vh"}> */}
        {/* Loading Overlay for Setup/Continue actions */}
        <OverlayLoader
          isOpen={Boolean(overlayLoading)}
          text={
            overlayLoading === "setup"
              ? "Setting up account..."
              : "Continuing application..."
          }
        />

        <Heading mb={6}>Withdrawals</Heading>

        <WithdrawalFilters
          filters={filters}
          updateFilter={updateFilter}
          handleExport={handleExport}
          handleReset={() => {
            setFilters(defaultWithdrawalsFilter);
          }}
          onRefresh={handleRefresh}
          exportLoading={exportLoading}
          isLoading={withdrawalsLoading} // Pass withdrawals loading to button
        />
        <UniversalTable
          columns={columns}
          data={withdrawals}
          error={error}
          isLoading={withdrawalsLoading} // Pass withdrawals loading to table
          showGlobalSearch={false}
          showColumnFilters={false}
          pagination={pagination}
          showPagination
          onPaginationChange={(page, itemsPerPage) => {
            updateFilter("itemsPerPage", itemsPerPage);
            updateFilter("page", page);
          }}
          tableName="Withdrawals"
          onRetry={fetchWithdrawals}
          isFiltered={
            objectToString(fiterFilters(filters, ["page", "itemsPerPage"])) !==
            ""
          }
          enableMultiSort={true}
          initialSortBy={sortRules}
          onSortChange={(rules) => {
            setSortRules(rules);
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      p={10}
      textAlign="center"
      mx="auto"
      maxW="600px"
      mt={10}
      height={"80vh"}
      position="relative"
    >
      {/* Loading Overlay for Setup/Continue actions */}
      <OverlayLoader
        isOpen={Boolean(overlayLoading)}
        text={
          overlayLoading === "setup"
            ? "Setting up account..."
            : "Continuing application..."
        }
      />

      <Helmet>
        <title>Banking - PurelyGive</title>
        <meta
          name="description"
          content="Manage your banking information securely on PurelyGive. Set up withdrawals and view transaction history with confidence."
        />
        <meta
          name="keywords"
          content="banking, withdrawals, transaction history, secure payments, PurelyGive"
        />
        <meta
          property="og:title"
          content="Secure Banking Management - PurelyGive"
        />
        <meta
          property="og:description"
          content="Securely manage your bank details and set up withdrawals for your fundraising campaigns on PurelyGive."
        />
        <meta property="og:image" content="/images/share-image.png" />
        <meta property="og:url" content="https://purelygive.com/banking" />
      </Helmet>
      <Icon as={FaUniversity} boxSize={16} color="orange.400" mb={4} />
      <Text fontSize="xl" fontWeight="bold" mb={4}>
        Banking info is required to start accepting payments.
      </Text>

      {(application_status === "in_review" ||
        application_status === "pending") && (
        <>
          <Text fontSize="md" mb={8}>
            Current application status: <strong>{application_status}</strong>
          </Text>
          <Text fontSize="md" color="green.600" mb={3}>
            Your application is currently being reviewed. Please wait patiently.
          </Text>
          <Text fontSize="md" color="gray.700" mb={8}>
            If you need assistance, reach out to us at{" "}
            <Link href={`mailto:${supportEmail}`} color="blue.500">
              {supportEmail}
            </Link>
            .
          </Text>
          <Text fontSize="sm" color="gray.600" mt={6}>
            If you believe you made a mistake on your application, you can{" "}
            <Link
              onClick={() => {
                setOverlayLoading("setup");
                handleSetupAccount();
              }}
              color="blue.500"
              cursor="pointer"
            >
              start a brand new application now
            </Link>
            .
          </Text>
        </>
      )}

      {application_status === "rejected" && (
        <>
          <Text fontSize="md" mb={8}>
            Current application status: <strong>{application_status}</strong>
          </Text>
          <Text fontSize="md" color="red.500" mb={8}>
            Your application has been rejected. We will reach out to you
            shortly, or you can contact us at support@purelygive.com.
          </Text>
        </>
      )}

      {application_status !== "rejected" &&
        application_status !== "in_review" &&
        application_status !== "pending" &&
        application_status !== "active" && (
          <>
            <Button
              colorScheme="orange"
              size="lg"
              leftIcon={<FaUniversity />}
              onClick={() => {
                if (hasExistingStripeAccount) {
                  setOverlayLoading("continue");
                  handleContinueApplication();
                } else {
                  setOverlayLoading("setup");
                  handleSetupAccount();
                }
              }}
              isLoading={actionLoading}
              loadingText={
                hasExistingStripeAccount ? "Continuing..." : "Setting up..."
              }
            >
              {hasExistingStripeAccount
                ? "Continue Banking Application"
                : "Setup Account"}
            </Button>

            {hasExistingStripeAccount && (
              <Link
                mt={4}
                onClick={() => {
                  setOverlayLoading("setup");
                  handleSetupAccount();
                }}
                color="blue.500"
                display="block"
                cursor="pointer"
              >
                Start a brand new application
              </Link>
            )}
          </>
        )}
    </Box>
  );
};

export default Banking;
